module.exports = __webpack_public_path__ + "static/maj-britt-2-7f43e759be6c44f5f9deb3cb8affb113.jpg";